import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectMakeList } from "../../../redux/features/make/makeSlice";

const BrandShowcase = () => {

  const {data: vehicleBrands} = useSelector(selectMakeList);

  const [visibleCount, setVisibleCount] = useState(4);
  const [chunkedBrands, setChunkedBrands] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const getChunkedBrands = (brands, count) => {
    if (!brands.length || count <= 0) return [];

    const result = [];
    const totalChunks = Math.ceil(brands.length / count);

    for (let i = 0; i < totalChunks; i++) {
      const start = i * count;
      const end = start + count;
      const chunk = brands.slice(start, end);
      result.push(chunk);
    }

    const lastChunk = result[result.length - 1];

    if (lastChunk.length < count) {
      const itemsNeeded = count - lastChunk.length;
      const fillerItems = brands.slice(0, itemsNeeded);
      result[result.length - 1] = lastChunk.concat(fillerItems);
    }

    return result;
  };

  const updateVisibleCount = () => {
    const width = window.innerWidth;

    if (width <= 430) setVisibleCount(2);
    else if (width <= 576) setVisibleCount(2);
    else if (width <= 774) setVisibleCount(3);
    else if (width <= 1024) setVisibleCount(4);
    else if (width <= 1200) setVisibleCount(5);
    else setVisibleCount(6);
  };

  useEffect(() => {
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);

    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  useEffect(() => {
    if (vehicleBrands?.length) {
      const chunks = getChunkedBrands(vehicleBrands, visibleCount);
      setChunkedBrands(chunks);
      setCurrentPage(0);
    }
  }, [vehicleBrands, visibleCount]);

  const goToPage = (index) => {
    setCurrentPage(index);
  };

  return (
    <div className={styles.mainDivWrapper}>
      {chunkedBrands.length !== 0 && (
        <div className={styles.brandWrapper}>
          <div className={styles.paginationControls}>

            <div className={styles.carousel}>
              {chunkedBrands[currentPage].map((brand, i) => (
                <Link
                  to={`/vehicles?make=${brand.name}`}
                  key={i}
                  className={styles.imageWrapper}
                >
                  <img
                    src={brand.image_url || ""}
                    width="130"
                    height="130"
                    alt={brand.name || ""}
                  />
                </Link>
              ))}
            </div>

          </div>

          <div className={styles.pageIndicators}>
            {chunkedBrands.length > 1 &&
              chunkedBrands.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => goToPage(idx)}
                  className={`${styles.indicator} ${
                    currentPage === idx ? styles.active : ""
                  }`}
                />
              ))}
          </div>

        </div>
      )}
    </div>
  );
};

export default BrandShowcase;